import styled from 'styled-components';

export const CalloutStyles = styled.div`
	margin: 2.5rem 0;
	border-radius: 0.5rem;
	padding: 1rem;
	background: ${({ theme }) => theme.v3.colors.gray[0]};

	.callout-image {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 50%;
		background: ${({ theme }) => theme.v3.colors.gray[2]};

		img {
			width: 1rem;
			height: 1rem;
			margin: 0;
		}
	}

	.content {
		padding-top: 0.25rem;
	}

	.title {
		margin-bottom: 0.25rem;
	}

	.link {
		display: inline-block;
		margin-top: 0.5rem;
		padding: 0.625rem 0;
		text-decoration: none;
	}
`;
